const KIOSK_URL = 'https://pos-frontend-kappa-two.vercel.app/?mode=kiosk'
import { Link } from 'react-router-dom'

export default function About() {
  return (
    <div className="py-12 md:py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-6">
            About <span className="text-yellow-500">Hanky Panky</span>
          </h1>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Late night smash burgers in Fayetteville, AR.
          </p>
        </div>

        {/* Story Section */}
        <div className="mb-16">
          <div className="bg-zinc-900 rounded-3xl p-8 md:p-12 border border-yellow-500/20">
            <h2 className="text-2xl md:text-3xl font-bold text-yellow-500 mb-6">
              Our Story
            </h2>
            <div className="space-y-4 text-gray-300">
              <p>
                Hanky Panky started with a simple idea: Fayetteville needed better
                late night food. Not just any food - properly smashed burgers with
                crispy edges, quality ingredients, and flavors that hit different
                after midnight.
              </p>
              <p>
                We operate out of Prelude Breakfast Bar, taking over the kitchen
                when the sun goes down. Same space, completely different vibe.
                While they do breakfast right, we do late night right.
              </p>
              <p>
                Every burger is smashed fresh on a hot griddle, creating that
                perfect crust that makes a smash burger what it is. No heat lamps,
                no shortcuts - just damn good burgers made to order.
              </p>
            </div>
          </div>
        </div>

        {/* Values Grid */}
        <div className="mb-16">
          <h2 className="text-2xl md:text-3xl font-bold text-white text-center mb-10">
            What We <span className="text-yellow-500">Stand For</span>
          </h2>

          <div className="grid sm:grid-cols-2 gap-6">
            <ValueCard
              title="Fresh Beef"
              description="Quality beef, smashed fresh to order. Never frozen patties sitting under a heat lamp."
              icon="fire"
            />
            <ValueCard
              title="Crispy Edges"
              description="The smash technique creates those caramelized, crispy edges that make all the difference."
              icon="star"
            />
            <ValueCard
              title="Late Night"
              description="Open when you need us most. Because cravings don't follow a 9-5 schedule."
              icon="moon"
            />
            <ValueCard
              title="No BS"
              description="Simple menu, quality ingredients, fair prices. That's it."
              icon="heart"
            />
          </div>
        </div>

        {/* Location Section */}
        <div className="mb-16">
          <div className="bg-gradient-to-br from-yellow-500/10 to-yellow-600/5 rounded-3xl p-8 md:p-12 border border-yellow-500/20">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-6">
              Find <span className="text-yellow-500">Us</span>
            </h2>
            <p className="text-gray-300 mb-4">
              We're inside Prelude Breakfast Bar on Spring Street in Fayetteville.
              Look for the Hanky Panky sign when we're open.
            </p>
            <p className="text-gray-400 text-lg">
              509 W. Spring Street, Ste 210<br />
              Fayetteville, AR
            </p>
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center">
          <h2 className="text-2xl font-bold text-white mb-4">
            Ready to try a smash burger?
          </h2>
          <p className="text-gray-400 mb-6">
            Order online for quick pickup.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={KIOSK_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-yellow-500 hover:bg-yellow-400 text-black font-bold text-lg rounded-xl transition-all hover:scale-105"
            >
              Order Now
            </a>
            <Link
              to="/menu"
              className="px-8 py-4 border-2 border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-black font-bold text-lg rounded-xl transition-colors"
            >
              View Menu
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

function ValueCard({ title, description, icon }) {
  const icons = {
    fire: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
      </svg>
    ),
    heart: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    ),
    star: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
      </svg>
    ),
    moon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
      </svg>
    ),
  }

  return (
    <div className="bg-zinc-900 rounded-2xl p-6 border border-yellow-500/20 hover:border-yellow-500/40 transition-colors">
      <div className="w-14 h-14 bg-yellow-500/10 rounded-xl flex items-center justify-center text-yellow-500 mb-4">
        {icons[icon]}
      </div>
      <h3 className="text-lg font-bold text-white mb-2">{title}</h3>
      <p className="text-gray-400 text-sm">{description}</p>
    </div>
  )
}
